var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"mx-5"},[_c('el-col',[_c('el-card',{attrs:{"shadow":"never"}},[_c('PageHeader'),_vm._v(" "),_c('FilterList',{on:{"onEdit":_vm.getConfig}}),_vm._v(" "),(_vm.config)?_c('EditConfig',{attrs:{"config":_vm.config}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }